import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import Icon from '../Icon'

interface ImageDropzoneProps {
  onFileAccepted: (file: File) => void
  maxMbSize?: number
}

const ImageDropzone = ({ onFileAccepted, maxMbSize }: ImageDropzoneProps) => {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) return
    onFileAccepted(acceptedFiles[0])
  }, [onFileAccepted])

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
  } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'image/png': [],
      'image/jpeg': [],
      'image/webp': [],
      'image/svg+xml': [],
    },
    maxSize: maxMbSize
      ? maxMbSize * 1024 * 1024
      : undefined,
  })

  return (
    <div
      {...getRootProps()}
      className={`
        dropzone
        ${isDragActive ? 'active' : ''}
        ${isDragReject ? 'reject' : ''}
      `}
    >
      <input {...getInputProps()} />

      <label>
        {isDragActive
          ? <>Drop image here...</>
          : <>Drag & drop image here, or click to select</>
        }
      </label>
      <Icon
        name={'Upload'}
      />
    </div>
  )
}

export default ImageDropzone
